import { useState, useRef, useEffect } from "react";
import "./CalibrationGamesInstructions.css";
import Step from "./CalibrationGameSteps/Step";
import { Modal } from "antd";

const CalibrationGamesInstructions = () => {
  
  const videoRef = useRef(null);
  const [step, setStep] = useState(1);
  const [stream, setStream] = useState(null);
  const [open, setOpen] = useState(false);

  const startWebcam = async () => {

    try {
      // Request permission to access the webcam
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setStream(stream)
      // Set the state to indicate permission is granted
      // Attach the video stream to the video element
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error('Error accessing webcam:', err);
    }
  };

  const stopWebcam = () => {
    if (stream) {
      // Stop all tracks in the media stream
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };
  

  return (
    <section className="instruction-body">
      {step == 1 ? (
        <div className="container" id="outer-container">
          <div className="row">
            <p id="head-text">
              Welcome..! <br /> Are you ready?
            </p>
          </div>
          <div className="row">
            <div className="col">
              <button
                className="instruction-btn"
                onClick={() => {
                  setStep(2);
                }}
              >
                Yes, Continue!
              </button>
            </div>
          </div>
        </div>
      ) : step == 2 ? (
        <div className="container" id="outer-container">
          <div className="row">
            <p id="head-text">
              Please allow Camera and notification <br /> access to complete the
              calibration process.
            </p>
          </div>
          <div className="row">
            <div className="col">
              <button
                className="instruction-btn"
                onClick={() => {
                  setOpen(true);
                  startWebcam();
                }}
              >
                Click to allow access
              </button>
            </div>
          </div>
          <Modal
            className="warning-modal"
            centered
            open={open}
            onOk={()=>{stopWebcam();setOpen(false);setStep(3);}}
            onCancel={()=>{stopWebcam();setOpen(false);setStep(3);}}
          >
            <div className="warning-modal-style">
              <h2>Access Granted!</h2>
              <p>
                Please continue the process.
              </p>
            </div>
          </Modal>
        </div>
      ) : step == 3 ? (
        <div className="container" id="outer-container">
          <div className="row">
            <p id="head-text">Follow the cues to begin your journey!</p>
          </div>
          <div className="row">
            <div className="col">
              <button
                className="instruction-btn"
                onClick={() => {
                  setStep(4);
                }}
              >
                Let's Go...!
              </button>
            </div>
          </div>
        </div>
      ) : (
        <Step />
      )}
    </section>
  );
};

export default CalibrationGamesInstructions;
